// src/api/user.js
import request from '@/utils/request';
import { ElMessage } from 'element-plus';


// 注册接口（对接后端 /api/users/register）
export const register = (userData) => {
  return request.post('/users/register', userData);
};

// 登录接口（对接后端 /api/users/login）
export const login = (userData) => {
  return request.post('/users/login', userData);
};

// 获取用户信息（登录后调用）
export const PersonalCenter = () => {
  return request.get('/users/PersonalCenter');
};

// 验证码登录接口
export function loginBySms(data) {
  return request.post('/users/loginBySms', data);
}

// 获取短信验证码接口
export function getSmsCode(data) {
  return request.post('/users/getSmsCode', data);
}

// 忘记密码（验证码重置）
export function forgetPassword(data) {
  return request.post('/users/forgetPassword', data);
}

// 修改密码（登录后验证旧密码）
export function changePassword(data, config) {
  return request.post('/users/changePassword', data, config);
}

// 获取用户基本信息
export const getUserInfo = () => {
  return request.get('/users/info');
}

// 新增：刷新AccessToken（修正接口路径）
export function refreshToken(data){
  return request.post('/users/refreshToken', data);
}

// 检查用户名修改限制
export const checkUsernameModifyLimit = () => {
  return request.get('/users/checkUsernameModifyLimit');
};

// 更新个人信息（头像/用户名/性别/生日，后端对应updateUserInfo）
export const updateProfile = (data) => {
  return request.post('/users/update', data);
};
export const updateUserInfo = updateProfile;

// 敏感词校验接口
export const checkUsernameSensitive = (data) => {
  return request.post('/users/checkUsernameSensitive', data);
};

// 获取用户数据统计（订单数/收藏数/账单数）
export const getUserStats = (data) => {
  return request.get('/users/stats', data);
}

// 保留原有updateAvatar方法
export const updateAvatar = (data) => {
  return request.post('/users/update', data);
};

// 上传头像（单独处理Content-Type）
export const uploadAvatar = (file) => {
  const formData = new FormData();
  formData.append('avatar', file);
  return request.post('/users/uploadAvatar', formData, {
    headers: {'Content-Type': 'multipart/form-data'},
    transformRequest: [data => data]
  });
}

// 退出登录
export function logout(data) {
  return request.post('/users/logout', data);
}

// ********** 会员系统相关 **********
// 获取会员详细信息
export const getMemberInfo = () => {
  return request.get('/users/member-info');
};

// 用户签到
export const sign = () => {
  return request.post('/users/sign');
};

// 获取签到状态
export const getSignStatus = () => {
  return request.get('/users/sign-status');
};

// ********** 账号安全相关 **********
// 更新手机号
export const updatePhone = (data) => {
  return request.post('/users/updatePhone', data);
};

// 注销账号
export const cancelAccount = (data) => {
  return request.post('/users/cancel', data);
};

// ********** 第三方绑定相关 **********
// 获取第三方绑定状态
export const getBindStatus = () => {
  return request.get('/users/bind/status')
    .then(response => {
      if (!response || !response.data) {
        ElMessage.warning('获取绑定状态为空，请刷新页面重试');
        return { code: 0, data: { jd: false, taobao: false, vip: false, douyin: false, pdd: false } };
      }

      const resData = response.data || response; // 适配request返回的res结构
      if (resData.code !== 0) {
        ElMessage.error(resData.msg || '获取绑定状态失败');
        return { code: resData.code, data: { jd: false, taobao: false, vip: false, douyin: false, pdd: false } };
      }

      return resData;
    })
    .catch(error => {
      console.error('获取绑定状态接口异常：', error);
      return Promise.reject({
        code: -1,
        msg: error.message || '网络异常，获取绑定状态失败',
        data: { jd: false, taobao: false, vip: false, douyin: false, pdd: false }
      });
    });
};

// 绑定第三方账号
export const bindThirdAccount = (data) => {
  return request.post('/users/bind', data)
    .catch(error => {
      if (error.response?.data?.msg?.includes('已绑定')) {
        ElMessage.info(error.response.data.msg);
      } else {
        ElMessage.error('生成授权链接失败，请稍后重试');
      }
      return Promise.reject(error);
    });
};

export const bindCashbackAccount = (data) => {
  return request({
    url: '/cashback/bind-account', // 对应后端接口地址
    method: 'post',
    data
  });
};

// 解绑第三方账号
export const unbindThirdAccount = (type) => {
  return request.delete(`/users/bind/${type}`);
};

// ********** 收货地址相关 **********
// 获取地址列表
export const getAddressList = () => {
  return request.get('/users/addresses');
};

// 获取地址详情
export const getAddressDetail = (id) => {
  return request.get(`/users/addresses/${id}`);
};

// 添加地址
export const addAddress = (data) => {
  return request.post('/users/addresses', data);
};

// 更新地址
export const updateAddress = (id, data) => {
  return request.put(`/users/addresses/${id}`, data);
};

// 删除地址
export const deleteAddress = (id) => {
  return request.delete(`/users/addresses/${id}`);
};

// 设置默认地址
export const setDefaultAddress = (id) => {
  return request.post(`/users/addresses/${id}/default`);
};

// ********** 图形验证码相关 **********
// 生成图形验证码
export const createCaptcha = () => {
  return request.get('/captcha/create');
};

// 验证图形验证码
export const verifyCaptcha = (data) => {
  return request.post('/captcha/verify', data);
};

export default request; // 导出统一的request实例
